// src/icons/VisaLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function VisaLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 8,
    viewBox: "0 0 23 8",
    width: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M5.76483 7.60344H3.77942L2.2906 1.92351C2.21993 1.66224 2.06989 1.43125 1.84918 1.32239C1.29838 1.0488 0.691425 0.831074 0.0292969 0.721262V0.502585H3.22764C3.66906 0.502585 4.00013 0.831074 4.0553 1.21258L4.82779 5.3097L6.81223 0.502585H8.74247L5.76483 7.60344ZM9.84607 7.60344H7.97101L9.51501 0.502585H11.3901L9.84607 7.60344ZM13.8159 2.46979C13.871 2.08734 14.2021 1.86866 14.5883 1.86866C15.1953 1.81376 15.8564 1.92357 16.4082 2.1962L16.7393 0.667356C16.1875 0.448679 15.5806 0.338867 15.0298 0.338867C13.2099 0.338867 11.8856 1.32244 11.8856 2.68752C11.8856 3.726 12.8236 4.27127 13.4858 4.59976C14.2021 4.9273 14.478 5.14598 14.4228 5.47352C14.4228 5.96484 13.871 6.18352 13.3202 6.18352C12.6581 6.18352 11.996 6.01974 11.39 5.74616L11.0589 7.27595C11.7211 7.54859 12.4374 7.6584 13.0995 7.6584C15.1401 7.71236 16.4082 6.72973 16.4082 5.25485C16.4082 3.39751 13.8159 3.28864 13.8159 2.46979ZM22.9706 7.60344L21.4817 0.502585H19.8826C19.5515 0.502585 19.2204 0.721262 19.1101 1.0488L16.3531 7.60344H18.2834L18.6687 6.56591H21.0403L21.261 7.60344H22.9706ZM20.1584 2.41464L20.7092 5.09083H19.1652L20.1584 2.41464Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  VisaLogo
};
//# sourceMappingURL=VisaLogo.mjs.map